var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"bulletin","pt-0":"","pb-3":"","px-3":""}},[_c('v-container',{attrs:{"id":"bulletin-container","pa-0":""}},[_c('v-flex',{attrs:{"fill-height":"","align-center":"","d-flex":""}},[_c('v-img',{attrs:{"src":_vm.step.url.url,"contain":"","max-height":"100%","max-width":"100%"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }